import { render, staticRenderFns } from "./TransmittedProgressWrapper.vue?vue&type=template&id=96f3e212"
import script from "./TransmittedProgressWrapper.vue?vue&type=script&lang=js"
export * from "./TransmittedProgressWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports